import preferences from "./preferences";

const TOKEN_KEY = "jwtToken";
const USER_INFO = "userInfo";

const parse = JSON.parse;
const stringify = JSON.stringify;

const auth = {
	/**
	 * Remove an item from the used storage
	 * @param  {String} key [description]
	 */
	clear: async (key) => {
		return await preferences.clear(key);
	},

	clearToken: async (tokenKey = TOKEN_KEY) => {
		return await auth.clear(tokenKey);
	},

	clearUserInfo: async (userInfo = USER_INFO) => {
		return auth.clear(userInfo);
	},

	/**
	 * Returns data from storage
	 * @param  {String} key Item to get from the storage
	 * @return {String|Object}     Data from the storage
	 */
	get(key) {
		return parse(preferences.getKey(key));
	},

	getToken(tokenKey = TOKEN_KEY) {
		return auth.get(tokenKey);
	},

	getUserInfo(userInfo = USER_INFO) {
		return auth.get(userInfo);
	},

	isAuthenticated() {
		return !!auth.getToken();
	},

	/**
	 * Set data in storage
	 * @param {String|Object}  value    The data to store
	 * @param {String}  key
	 * @param {Boolean} isLocalStorage  Defines if we need to store in localStorage or sessionStorage
	 */
	set: async (value, key, isLocalStorage) => {
		// console.log(
		// 	`[auth] value: ${value}, key: ${key}, isLocal: ${isLocalStorage}`
		// );

		if (!value) {
			return null;
		}

		return await preferences.setKey(key, stringify(value));
	},

	setToken: async (
		value = "",
		isLocalStorage = false,
		tokenKey = TOKEN_KEY
	) => {
		return await auth.set(value, tokenKey, isLocalStorage);
	},

	setUserInfo: async (
		value = "",
		isLocalStorage = false,
		userInfo = USER_INFO
	) => {
		return await auth.set(value, userInfo, isLocalStorage);
	},
};

export default auth;
